import React from 'react';
import { APP_TOKEN_KEY, VALID_GAME_ID } from '@root/constants';
import { InvalidGameIdScreen } from '@root/feature/screens';
import { useAuthFlow } from '@shared/hooks';
import { useOneTimeTokenLoginMutation } from '@shared/store/api/auth';
import styles from './AuthLayout.module.scss';

const AuthLayout: React.FC = () => {
  const [loginMutation] = useOneTimeTokenLoginMutation();
  const { error, isInvalidGame } = useAuthFlow({
    appTokenKey: APP_TOKEN_KEY,
    validGameId: VALID_GAME_ID,
    login: (params) => loginMutation(params).unwrap(),
  });

  if (isInvalidGame) return <InvalidGameIdScreen />;

  return (
    <div className={styles.container}>
      {!error && 'Please wait...'}
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export default AuthLayout;
